import { isEvmCrypto } from 'shared/src/cryptoUtils';

import { CHAIN_CONFIG } from './config';

const NON_EVM_NETWORKS = ['tron', 'trc20'];

export const buildEip681Uri = ({
  depositAddress,
  network
}: {
  depositAddress: string;
  network: string;
}): string | undefined => {
  const config = CHAIN_CONFIG[network.toLowerCase()];
  if (!config) return undefined;

  return `ethereum:${depositAddress}@${config.chainId}`;
};

export const buildQRCode = ({
  depositAddress,
  asset,
  network
}: {
  depositAddress: string;
  asset: string;
  network: string;
}): string | undefined => {
  if (!isEvmCrypto(asset)) return undefined;
  if (NON_EVM_NETWORKS.includes(network.toLowerCase())) return undefined;

  return buildEip681Uri({ depositAddress, network });
};

export const shiftDecimal = (value: number, decimals: number): string => {
  const str = String(value).padStart(decimals + 1, '0');
  const cut = str.length - decimals;
  const result = `${str.slice(0, cut)}.${str.slice(cut)}`.replace(/\.?0+$/, '');
  return result;
};
